
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta } from "/app/pages/logout.vue?macro=true";
import { default as apizI_45RuAh4WyeLAafdGlYthReY6DXRC9DPnvhOSQbjzBkMeta } from "/app/pages/docs/api.vue?macro=true";
import { default as socketzLIW7LhZMcIybKTfABiFdOp14W3DqFO7z28SvPwTD_45gMeta } from "/app/pages/dev/socket.vue?macro=true";
import { default as indexZdOI5z1Cd4ocPHGvnaBe78eX64Aze6fApj9uUNKgpN0Meta } from "/app/pages/team/index.vue?macro=true";
import { default as _91id_93lDIeSz2wOF34RzwIu_45BAX4BgVwsMW2q9J7W_45FtVejv8Meta } from "/app/pages/invite/[id].vue?macro=true";
import { default as index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta } from "/app/pages/login/index.vue?macro=true";
import { default as indexDCqhPzutOZTeEBErhbpXyxz9LSZCrOqFoLSpaIOOmIIMeta } from "/app/pages/orders/index.vue?macro=true";
import { default as indexv46crOPEOD1SXWkWSW_45c6zJmxY7RF9_45TCFlqQM21EmIMeta } from "/app/pages/stocks/index.vue?macro=true";
import { default as consentiobtSVMnp_45HiCYbV84dbdZpv_l8wWQEkM6nG9TXz1TsMeta } from "/app/pages/oauth/consent.vue?macro=true";
import { default as create_w24JVjVPS7FAEMSpkfAteA9DqN6lyiZYCKqNBR8pNQMeta } from "/app/pages/orders/create.vue?macro=true";
import { default as _91id_93wwX_FREXDwBWoYAL84CknW5yzeJhIbSSR5bA3y3A2YMMeta } from "/app/pages/register/[id].vue?macro=true";
import { default as userCsQ3oKZxGbvqInuO4rajkdYazHVDgW6pmcDowf8zdzUMeta } from "/app/pages/settings/user.vue?macro=true";
import { default as index0YSZp_45y0UoCapFKQ_Il3F8GPbtj_454QM7Oki5qkmQt7EMeta } from "/app/pages/welcome/index.vue?macro=true";
import { default as indexxAc4Y53avL8uOViqBui4IoShKJWHAzwvvMoBQbO0M_45oMeta } from "/app/pages/payments/index.vue?macro=true";
import { default as indexEP180Yte9j5FYHqKOKcwLWqDK4mSPrhNYq9YGvhURlIMeta } from "/app/pages/printers/index.vue?macro=true";
import { default as indexyamhl0wGj7h0OUvZf48XLG1L3YBKP6iUdj9ycXy74rUMeta } from "/app/pages/register/index.vue?macro=true";
import { default as index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as stocksSpa5tTGyupaD6qbHDX4wtBsUFgPHNFyr4g_45eOuruLs0Meta } from "/app/pages/printers/stocks.vue?macro=true";
import { default as indexb2obLVbnagwIUZRC5bE90RqSK0lmkU1ppAWfI5qw6Y4Meta } from "/app/pages/developers/index.vue?macro=true";
import { default as indexcSE4CkXdMMAYDEjx3ppz8s9n3joRFHI0fpQOqfc68QAMeta } from "/app/pages/management/index.vue?macro=true";
import { default as queuelZDOSlf5cCLkVp3cnNq_jBu_uUX1R_NF7TbBJAPK8jgMeta } from "/app/pages/management/queue.vue?macro=true";
import { default as tokeneG9QQnVqd78eiAfa7_454rlHyz1HyLfhiC7oeVUHWcScEMeta } from "/app/pages/management/token.vue?macro=true";
import { default as indexUVBClvupsRCX2G6PsxxLFj_Cptg_0DzxwuByyCSKk1MMeta } from "/app/pages/onboarding/index.vue?macro=true";
import { default as billingGeSuJUhGp0SsNIlGsdggvabISaTVbBtYE7IFgmgoR3AMeta } from "/app/pages/printers/billing.vue?macro=true";
import { default as accountYaW2Hju_BYde55CgkuaY5YUTw34fttXrs6fR3vDa4fsMeta } from "/app/pages/settings/account.vue?macro=true";
import { default as billingxLC_slppFM8RXhaAChpDrb5AmAWYUxU5hgjtO41Mrx8Meta } from "/app/pages/settings/billing.vue?macro=true";
import { default as configWcULm6yAmk4o_47gcfgQNYeydJ0Ix97VdBIui4u3YaMMeta } from "/app/pages/management/config.vue?macro=true";
import { default as delayse1J1XRRdmmJZWVjVn82OvOIZTm4fnMX2CGAtgk9dAToMeta } from "/app/pages/management/delays.vue?macro=true";
import { default as orderszCnegv5QsjQNmr208NSg069JeUYyQX_QIJYh9p_abYgMeta } from "/app/pages/management/orders.vue?macro=true";
import { default as stocksb_aSo7c0V9vvY_453qf45dF_45BaBtJG4XkaRezLdUpPQ20Meta } from "/app/pages/management/stocks.vue?macro=true";
import { default as exports92o_EnZjMg_45k4xdV7dAuUjU_Ku2xPS_SOEBmYCTDLCEMeta } from "/app/pages/management/exports.vue?macro=true";
import { default as index_45bVxenuO_45iDbb_45mDZ2hhjtxgnBdfDpI6xx18bsJF9EkMeta } from "/app/pages/verify-email/index.vue?macro=true";
import { default as accountsZUC8GZDcT3pGmiGHmlSZzLtcF_45z6amniaz5L9jDKuzAMeta } from "/app/pages/management/accounts.vue?macro=true";
import { default as carriersG7vsBhjOO7n1XTnnOjiUS_hvGHefRpL_wcppS4F3LiIMeta } from "/app/pages/management/carriers.vue?macro=true";
import { default as _91id_93XFqEqZb6Xt4Kvs7NEURLJR2ZSkBPbHMrzn4tNowyoAAMeta } from "/app/pages/password-reset/[id].vue?macro=true";
import { default as indexsWe5rLV7JSWva21uKolu1bwI7OB2OqsLbcx3KD9fmNMMeta } from "/app/pages/subscriptions/index.vue?macro=true";
import { default as indexa7JIWW5Wwy_45k1sMLugZenV3f1e0K_45hdjqoGW23izk88Meta } from "/app/pages/password-reset/index.vue?macro=true";
import { default as productions1kuMofgO5rNS5iQDOj3Rbr0q8UNGrZmNTSQsuliwTp8Meta } from "/app/pages/printers/productions.vue?macro=true";
import { default as _91token_93vi608SF0hIHgqe_454wl2nFlMr1Mk4wyZp2_45cQuwfSvkgMeta } from "/app/pages/verify-email/[token].vue?macro=true";
import { default as amazon_45csv9GI_4538NQE70rDvdPCDj47SXPAglOkSfFfzujnMADJJYMeta } from "/app/pages/management/amazon-csv.vue?macro=true";
import { default as transactions0gAW2BBULiyimWdwZTcsGIeO2J8Mgwlp687_45FkhPhmkMeta } from "/app/pages/printers/transactions.vue?macro=true";
import { default as productionsRNoJ3skPW6l_456E7olGdtTfclaDHKzMH5h5IYB72QyRsMeta } from "/app/pages/management/productions.vue?macro=true";
import { default as _91id_93j7L_O9A704cBxAZnE5OUPpFtiT3YA8nHTK3HidWhMRwMeta } from "/app/pages/developers/webhooks/[id].vue?macro=true";
import { default as printer_45statementse1B7P_0D5EG4illGaReD_45DdidvALrEWQ65FaQryC3aIMeta } from "/app/pages/management/printer-statements.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "docs-api",
    path: "/docs/api",
    component: () => import("/app/pages/docs/api.vue")
  },
  {
    name: "dev-socket",
    path: "/dev/socket",
    component: () => import("/app/pages/dev/socket.vue")
  },
  {
    name: "team",
    path: "/team",
    component: () => import("/app/pages/team/index.vue")
  },
  {
    name: "invite-id",
    path: "/invite/:id()",
    meta: _91id_93lDIeSz2wOF34RzwIu_45BAX4BgVwsMW2q9J7W_45FtVejv8Meta || {},
    component: () => import("/app/pages/invite/[id].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta || {},
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/app/pages/orders/index.vue")
  },
  {
    name: "stocks",
    path: "/stocks",
    component: () => import("/app/pages/stocks/index.vue")
  },
  {
    name: "oauth-consent",
    path: "/oauth/consent",
    meta: consentiobtSVMnp_45HiCYbV84dbdZpv_l8wWQEkM6nG9TXz1TsMeta || {},
    component: () => import("/app/pages/oauth/consent.vue")
  },
  {
    name: "orders-create",
    path: "/orders/create",
    component: () => import("/app/pages/orders/create.vue")
  },
  {
    name: "register-id",
    path: "/register/:id()",
    meta: _91id_93wwX_FREXDwBWoYAL84CknW5yzeJhIbSSR5bA3y3A2YMMeta || {},
    component: () => import("/app/pages/register/[id].vue")
  },
  {
    name: "settings-user",
    path: "/settings/user",
    component: () => import("/app/pages/settings/user.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: index0YSZp_45y0UoCapFKQ_Il3F8GPbtj_454QM7Oki5qkmQt7EMeta || {},
    component: () => import("/app/pages/welcome/index.vue")
  },
  {
    name: "payments",
    path: "/payments",
    component: () => import("/app/pages/payments/index.vue")
  },
  {
    name: "printers",
    path: "/printers",
    component: () => import("/app/pages/printers/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: indexyamhl0wGj7h0OUvZf48XLG1L3YBKP6iUdj9ycXy74rUMeta || {},
    component: () => import("/app/pages/register/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "printers-stocks",
    path: "/printers/stocks",
    component: () => import("/app/pages/printers/stocks.vue")
  },
  {
    name: "developers",
    path: "/developers",
    component: () => import("/app/pages/developers/index.vue")
  },
  {
    name: "management",
    path: "/management",
    component: () => import("/app/pages/management/index.vue")
  },
  {
    name: "management-queue",
    path: "/management/queue",
    component: () => import("/app/pages/management/queue.vue")
  },
  {
    name: "management-token",
    path: "/management/token",
    component: () => import("/app/pages/management/token.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    component: () => import("/app/pages/onboarding/index.vue")
  },
  {
    name: "printers-billing",
    path: "/printers/billing",
    component: () => import("/app/pages/printers/billing.vue")
  },
  {
    name: "settings-account",
    path: "/settings/account",
    component: () => import("/app/pages/settings/account.vue")
  },
  {
    name: "settings-billing",
    path: "/settings/billing",
    component: () => import("/app/pages/settings/billing.vue")
  },
  {
    name: "management-config",
    path: "/management/config",
    component: () => import("/app/pages/management/config.vue")
  },
  {
    name: "management-delays",
    path: "/management/delays",
    component: () => import("/app/pages/management/delays.vue")
  },
  {
    name: "management-orders",
    path: "/management/orders",
    component: () => import("/app/pages/management/orders.vue")
  },
  {
    name: "management-stocks",
    path: "/management/stocks",
    component: () => import("/app/pages/management/stocks.vue")
  },
  {
    name: "management-exports",
    path: "/management/exports",
    component: () => import("/app/pages/management/exports.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: index_45bVxenuO_45iDbb_45mDZ2hhjtxgnBdfDpI6xx18bsJF9EkMeta || {},
    component: () => import("/app/pages/verify-email/index.vue")
  },
  {
    name: "management-accounts",
    path: "/management/accounts",
    component: () => import("/app/pages/management/accounts.vue")
  },
  {
    name: "management-carriers",
    path: "/management/carriers",
    component: () => import("/app/pages/management/carriers.vue")
  },
  {
    name: "password-reset-id",
    path: "/password-reset/:id()",
    meta: _91id_93XFqEqZb6Xt4Kvs7NEURLJR2ZSkBPbHMrzn4tNowyoAAMeta || {},
    component: () => import("/app/pages/password-reset/[id].vue")
  },
  {
    name: "subscriptions",
    path: "/subscriptions",
    component: () => import("/app/pages/subscriptions/index.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexa7JIWW5Wwy_45k1sMLugZenV3f1e0K_45hdjqoGW23izk88Meta || {},
    component: () => import("/app/pages/password-reset/index.vue")
  },
  {
    name: "printers-productions",
    path: "/printers/productions",
    meta: productions1kuMofgO5rNS5iQDOj3Rbr0q8UNGrZmNTSQsuliwTp8Meta || {},
    component: () => import("/app/pages/printers/productions.vue")
  },
  {
    name: "verify-email-token",
    path: "/verify-email/:token()",
    meta: _91token_93vi608SF0hIHgqe_454wl2nFlMr1Mk4wyZp2_45cQuwfSvkgMeta || {},
    component: () => import("/app/pages/verify-email/[token].vue")
  },
  {
    name: "management-amazon-csv",
    path: "/management/amazon-csv",
    component: () => import("/app/pages/management/amazon-csv.vue")
  },
  {
    name: "printers-transactions",
    path: "/printers/transactions",
    component: () => import("/app/pages/printers/transactions.vue")
  },
  {
    name: "management-productions",
    path: "/management/productions",
    component: () => import("/app/pages/management/productions.vue")
  },
  {
    name: "developers-webhooks-id",
    path: "/developers/webhooks/:id()",
    component: () => import("/app/pages/developers/webhooks/[id].vue")
  },
  {
    name: "management-printer-statements",
    path: "/management/printer-statements",
    component: () => import("/app/pages/management/printer-statements.vue")
  }
]